import { Directive } from '@angular/core';

@Directive()
// eslint-disable-next-line @angular-eslint/directive-class-suffix
export abstract class Pattern {
    public faxPattern: string = '[+? *[0-9]+]?[0-9]+';
    public phonePattern: string = '^(?:(?:\\+|00)33|0)\\s*[1-9](?:[\\s.-]*\\d{2}){4}$';
    public emailPattern: string = '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$';
    public unitPricePattern: string = '^[0-9]+(([.,])+[0-9]{1,2})?$';
    public maxDurationPattern: string = '^[0-9]+$';
    public smsPattern: string = '^(0|\\+33|0033)[1-9][0-9]{8}$';
}
